<template>
  <div>
    <loadingCube v-if="!loading_contact" :loadingMessage="'CONTACT'"></loadingCube>
    <div v-else class="record">
      <b-tabs v-model="contact_profile_tabIndex" pills vertical>
        <template v-slot:tabs-start>
          <div class="record_info">
            <h2 class="font-weight-bold bp_color mb-0">{{ contact.person.first_name }} {{ contact.person.surname }}</h2>
            <h5>{{ contact.company.company_name }}</h5>
            <hr>
            <div v-if="contact.rel_profile.job_title_id !== null">
              <strong><i class="fas fa-user-tie"></i></strong>{{ contact.rel_profile.job_title.job_title }}
            </div>
            <div v-if="contact.phones !== null && contact.phones.work_landline !== null">
              <strong><i class="fas fa-phone-alt"></i></strong>{{ contact.phones.work_landline }}
            </div>
            <div v-if="contact.phones !== null && contact.phones.work_mobile !== null">
              <strong><i class="fas fa-mobile-alt"></i></strong>{{ contact.phones.work_mobile }}
            </div>
            <div v-if="contact.phones !== null && contact.phones.personal_landline !== null">
              <strong><i class="fas fa-phone-alt"></i></strong>{{ contact.phones.personal_landline }}
            </div>
            <div v-if="contact.phones !== null && contact.phones.personal_mobile !== null">
              <strong><i class="fas fa-mobile-alt"></i></strong>{{ contact.phones.personal_mobile }}
            </div>
            <div v-if="contact.emails !== null && contact.emails.work_email !== null">
              <strong><i class="fas fa-at"></i></strong><a :href="'mailto:' + contact.emails.work_email" class="email_link">{{ contact.emails.work_email }}</a></div>
            <div v-if="contact.emails !== null && contact.emails.personal_email !== null">
              <strong><i class="fas fa-at"></i></strong><a :href="'mailto:' + contact.emails.personal_email" class="email_link">{{ contact.emails.personal_email }}</a></div>
            <!--      <div v-if="contact.address !== null"><strong><i class="fas fa-home"></i></strong>{{contact.address}}</div>-->
          </div>
        </template>
        <div class="record_short_btns">
          <div class="row">
            <div class="col-6 text-left">
              <!--       <button @click="createEmail" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Send Email"><i class="fas fa-paper-plane"></i> &nbsp;Email</button>-->
              <!--       <button @click="createEvent" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Create Event"><i class="fas fa-calendar-plus"></i> &nbsp; Event</button>-->
              <!--       <button @click="createTask" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1 disabled" disabled data-toggle="tooltip" title="Create Task"><i class="fas fa-plus-square"></i> &nbsp; Task</button>-->
            </div>
            <div class="col-6">
              <button @click="add_note_modal" class="btn orcaBtn sm_btn mb-2 mr-1 ml-1" data-toggle="tooltip" title="Add Note to Contact">
                <i class="fas fa-plus"></i> &nbsp; add note
              </button>
              <button @click="edit_contact" class="btn orcaBtn sm_btn greenBtn mb-2 mr-1 ml-1" data-toggle="tooltip" title="Add Note to Contact">
                <i class="fas fa-user-edit"></i>&nbsp; edit contact
              </button>
            </div>
          </div>
        </div>
        <b-tab title="Notes" lazy>
          <b-card-text>
            <notes :notes="notes" :notesLoaded="notes_loaded"></notes>
          </b-card-text>
        </b-tab>
        <b-tab title="Events & Tasks" lazy disabled>
          <b-card-text>
            <events_tasks></events_tasks>
          </b-card-text>
        </b-tab>
        <b-tab title="Emails" lazy disabled>
          <b-card-text>
            <emails></emails>
          </b-card-text>
        </b-tab>
        <b-tab title="Activity on Profile" lazy v-if="canViewLogs()">
          <b-card-text>
            <activity :logs="activity" :logsLoaded="activity_loaded"></activity>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import notes from "pages/companies/contacts/record/notes";
import activity from "pages/companies/contacts/record/activity";
import events_tasks from "pages/companies/contacts/record/events_tasks";
import emails from "pages/companies/contacts/record/emails";

export default {
  name: "contact_profile",
  components: {
    loadingCube,
    notes,
    activity,
    events_tasks,
    emails
  },
  data() {
    return {
      contact_id: this.$store.state.contacts.current_profile_contact_id,
      contact_profile_tabIndex: this.$store.state.contacts.current_profile_tab_index,

      loading_contact: false,

      contact: {},
      notes_loaded: false,
      notes: [],

      activity_loaded: false,
      activity: []
    }
  },
  computed: {
    contact_reload() {
      return this.$store.state.contacts.reload_contacts;
    },
    note_reload() {
      return this.$store.state.notes.reload_notes;
    },
    activity_reload() {
      return this.$store.state.logs.reload_logs;
    }
  },
  beforeMount() {
    let contactId = this.contact_id;

    if(this.$route.query.contact_id){
      contactId = this.$route.query.contact_id;
      this.contact_id = contactId;
    }

    this.get_contact_data().then(() => {
      this.get_contact_notes().then(() => {
        this.get_contact_logs().then(() => {
          this.loading_contact = true;
        })
      });
    })
  },
  watch: {
    contact_reload(val) {
      if (val === true) {
        this.loading_contact = false;
        this.get_contact_data().then(() => {
          this.loading_contact = true;
        })
      }
    },
    note_reload(val) {
      if (val === true) {
        this.notes_loaded = false;
        this.get_contact_notes()
      }
    },
    client_note_reload(val) {
      if (val === true) {
        this.notes_loaded = false;
        this.get_contact_notes()
      }
    },
    activity_reload(val) {
      if (val === true) {
        this.activity_loaded = false;
        this.get_contact_logs()
      }
    },
    contact_profile_tabIndex(tab) {
      this.$store.commit('SET_CONTACT_TAB_INDEX', tab)
    }
  },
  methods: {
    canViewLogs(){
      return this.$store.state.auth.me.permissions.includes('sunset_note_stats_restricted');
    },
    get_contact_data() {
      return axios.get(this.crmApiPath + 'contact/' + this.contact_id).then(contact => this.contact = contact.data)
    },
    get_contact_notes() {
      return axios.get(this.crmApiPath + 'sunset/notes/contact/' + this.contact_id).then(notes => {
        this.notes_loaded = true;
        this.notes = notes.data;
      })
    },
    get_contact_logs() {
      return axios.get(this.crmApiPath + 'sunset/logs/contact/' + this.contact_id).then(logs => {
        this.activity_loaded = true;
        this.activity = logs.data;
      });
    },
    createEmail() {
      this.$router.push('/email/create');
    },
    createEvent() {
      this.$router.push('/calendar/event/create');
    },
    createTask() {
      this.$router.push('/tasks/create');
    },
    add_note_modal() {
      this.$store.commit('SHOW_ADD_NOTE_MODAL', {
        id: this.contact.id,
        name: this.contact.person.first_name + ' ' + this.contact.person.surname,
        type: 'contact',
        contacts: this.contact
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_note_modal'));
    },
    edit_contact() {
      this.$store.commit('SHOW_EDIT_CONTACT_MODAL', {
        contact_id: this.contact.id,
        company_id: this.contact.client_id,
        row_node_id: null
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_contact_modal'))
    }
  }
}
</script>

<style scoped>

</style>
